import React from 'react';
import { useFooter } from '../../providers/FooterProvider';

export default function Footer() {
  const { content } = useFooter();

  return Boolean(content) && <div className="sticky bottom-0 z-50">{content}</div>;
}
